import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
`
